import type { ChallengeScope } from './type'

import { IssueChallengeRequestScopeEnum } from '@src/api/generated/user-api'

export function isChallengeScope(value: string): value is ChallengeScope {
  return Object.values(IssueChallengeRequestScopeEnum).some((s) => s === value)
}
